import { BreakpointWidth } from '@app/enumerations';
import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({

		tableTitle_title: {
			display: 'flex',
			justifyContent: 'space-between',
			margin: theme.spacing(2, 0, 1, 0),
		},
		tableTitle_titleContentWrapper: {
			display: 'flex',
		},
		tableTitle_postfixIconsContainer: {
			display: 'flex'
		},
		tableTitle_prefixIconsContainer: {
			display: 'flex',
		},
		tableTitle_prefixIconWrapper: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		tableTitle_prefixIconContainer: {
			marginRight: theme.spacing(1.5),
		},
		tableTitle_menuIconContainer: {
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				display: 'none',
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(0),
			},
		},
		tableTitle_menuIcon: {

		},
		tableTitle_backIconContainer: {
			padding: theme.spacing(0),
		},
		tableTitle_backIcon: {
			fontSize: theme.spacing(5),
		},	
	});
});

export default useStyles;
